module.exports = __webpack_public_path__ + "media/images/sectionBg--communities-e1ca83948774ce99136c54816742a2f6.jpg";